<div *ngIf="forgotLoginContent?.errorCode" class="form-alert" id="formAlertId">
  <idp-form-alert
    *ngIf="forgotLoginContent?.errorCode"
    (closePopup)="onClosePop()"
    [showCloseButton]="true"
    [message]="
      forgotLoginContent?.forgotLoginContent?.errors?.formAlertErrorMessage
    "
  ></idp-form-alert>
</div>
<idp-login-header
  [loginHeaderContent]="forgotLoginContent?.forgotLoginContent.pageHeader"
  (triggerClose)="triggerClose.emit()"
  [machCore]="machCore"
  class="forgot-login-header"
></idp-login-header>
<section
  *ngIf="
    forgotLoginContent?.forgotLoginAttributes?.submitAttempt &&
    forgotLoginContent?.forgotLoginAttributes?.errorAlertBanner
  "
  id="forgot-login-alert-banner"
>
  <idp-alert-warning
    #alertWarning
    (firstInvalidFieldFocusEvent)="firstInvalidFieldFocusEvent()"
    *ngIf="forgotLoginContent?.forgotLoginAttributes?.errorCount"
    [cntError]="forgotLoginContent?.forgotLoginAttributes?.errorCount"
    [errorMessage]="
      forgotLoginContent?.forgotLoginContent?.errors?.forgotLoginAlertWarning
    "
  ></idp-alert-warning>
</section>

<ng-container *ngIf="forgotLoginContent">
  <form [formGroup]="forgotLoginContent.formGroup" (ngSubmit)="submit()">
    <div class="forgot-login-fields">
      <div
        class="forgot-login-fields__email-address"
        [ngClass]="{
          fromStandAlone: fromStandAlone,
          fromModal: !fromStandAlone
        }"
      >
        <idp-input
          [labelTxt]="forgotLoginContent?.forgotLoginContent?.emailLabel"
          formControlName="emailId"
          id="forgotLoginEmailId"
          class="forgot-login__email-id"
          [hasLink]="true"
          (value)="onChange()"
          (focusOut)="onFocussedOut('emailId')"
          [infoToolTipContent]="
            forgotLoginContent?.forgotLoginContent?.emailAddressInfoContent
          "
          [infoToolTip]="forgotLoginContent?.forgotLoginAttributes?.isMfa"
        ></idp-input>
        <div *ngIf="showEmailIdErrorMessage" class="error-message__email">
          <span
            [innerHTML]="
              forgotLoginContent?.forgotLoginContent?.errors
                ?.emailIdErrorMessage
            "
          ></span>
        </div>
      </div>

      <div class="forgot-login-fields__first-name">
        <idp-input
          [labelTxt]="forgotLoginContent?.forgotLoginContent?.firstNameLabel"
          formControlName="firstName"
          id="forgotLoginFirstName"
          (value)="onChange()"
          (focusOut)="onFocussedOut('firstName')"
        ></idp-input>
        <div *ngIf="showFirstNameErrorMessage" class="error-message__firstname">
          <span
            [innerHTML]="
              forgotLoginContent?.forgotLoginContent.errors
                ?.firstNameErrorMessage
            "
          ></span>
        </div>
      </div>
      <div class="forgot-login-fields__last-name">
        <idp-input
          [labelTxt]="forgotLoginContent?.forgotLoginContent?.lastNameLabel"
          formControlName="lastName"
          id="forgotLoginLastName"
          (value)="onChange()"
          (focusOut)="onFocussedOut('lastName')"
        ></idp-input>
        <div *ngIf="showLastNameErrorMessage" class="error-message__lastname">
          <span
            [innerHTML]="
              forgotLoginContent?.forgotLoginContent?.errors
                ?.lastNameErrorMessage
            "
          ></span>
        </div>
      </div>
      <div class="forgot-login-button">
        <idp-button
          [label]="
            forgotLoginContent?.forgotLoginContent?.nextDisplayView
              ?.button_modal
          "
          [size]="'full-width'"
          [elementType]="'submit'"
          [disabled]="forgotLoginContent?.disableButton"
          [customClass]="'forgotLoginButton'"
        ></idp-button>
      </div>
    </div>
  </form>
</ng-container>
